//
export default [
    {
        field           : 'Global',
        type            : 'section',
    },
    {
        field           : 'warranty_days',
        type            : 'text',
        vuetifyProps    : {
            label       : 'Garantía',
            mask        : '######',
            suffix      : '[Dias]',
        },
    },
    {
        field           : 'is_tax_free',
        type            : 'checkbox',
        vuetifyProps    : {
            label       : 'Producto libre de impuesto',
        },
        value           : false,
    },
    {
        field           : 'is_salable',
        type            : 'checkbox',
        vuetifyProps    : {
            label       : 'Producto Vendible',
            falseValue: false,
        },
        value           : false,
    },
    {
        field           : 'is_consumable',
        type            : 'checkbox',
        vuetifyProps    : {
            label       : 'Producto Consumo interno',
            falseValue  : false,
        },
        value           : false,
    },
]